export enum LegalIssueType {
    LegalIssue = 0,
    AdditionalCovenant = 1,
}
